import { User } from '@/modules/user/user';
import { Tag } from '@/modules/tag/tag';
import { validateDevice } from '@shared/common/data-validators/device.validator';

export class Device {

    public static validate(device: any): string[] {
        return validateDevice(device);
    }

    public static generatePinCode(pinLength = 4):  string {
        let pin = '';
        const nums = ['1', '2', '3', '4', '5', '6', '7',
            '8', '9', '0'];

        for (let i = 0; i < pinLength; i++) {
            pin += String(Math.floor(Math.random() * nums.length));
        }

        return pin;
    }
    public id!: string;
    public incrementalId!: number;
    public label!: string;
    public comment?: string;
    public createdAt!: Date;
    public subscriptionStart!: Date;
    public subscriptionEnd!: Date;
    public owner?: User;
    public ownerId!: string;
    public tag!: Tag;
    public tagId!: string;
    public createdBy?: User;
    public createdById!: string;
    public updatedBy?: User;
    public updatedById!: string;
    public subscriptionConfigSyncedWithDevice!: boolean;
    public socketConnected = false;
    public batteryLevel?: number;
    public protectionOn!: boolean;
    public deletedAt?: Date;
    public deletedBy?: User;
    public deletedById?: string;

    constructor(opt: any) {
        Object.assign(this, opt);

        if (this.subscriptionStart) {
            this.subscriptionStart = new Date(this.subscriptionStart);
        }

        if (this.subscriptionEnd) {
            this.subscriptionEnd = new Date(this.subscriptionEnd);
        }

        if  (this.deletedAt) {
            this.deletedAt = new Date(this.deletedAt);
        }
    }
}
